/**
 * @copyright valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

/**
 * Safely parse a JSON string and return a fallback if parsing fails.
 * @param {string|null|undefined} value
 * @param {*} fallback
 * @returns {*}
 */
export const safeJsonParse = (value, fallback = null) => {
    if (typeof value !== 'string' || value.trim() === '') {
        return fallback
    }
    try {
        return JSON.parse(value)
    } catch (e) {
        return fallback
    }
}

